import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  canonicalUrl?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = 'Grand River Chinese School - Reading Comprehension System',
  description = "Grand River Chinese School's Grade Reading Comprehension System for Chinese language learning. Manage students, homework, and reading comprehension exercises.",
  keywords = 'Grand River Chinese School, Chinese language learning, reading comprehension, homework management, education platform, HSK, Mandarin learning',
  ogTitle,
  ogDescription,
  canonicalUrl,
}) => {
  const fullTitle = title.includes('Grand River Chinese School')
    ? title
    : `${title} | Grand River Chinese School`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description} />

      {/* Twitter */}
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description} />

      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};
